'use strict';

var SendFilesStream = require('../utils/send-files-stream');

var FileResultStreamConverter = require('../utils/file-result-stream-converter');

module.exports = function (send) {
  return function (options) {
    options = options || {};
    options.converter = FileResultStreamConverter;
    return SendFilesStream(send, 'add')(options);
  };
};